import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class LoaderService {

  activeLoader: Subject<boolean>;

  constructor() {
    this.activeLoader = new Subject<boolean>();
  }

  show(): void {
    this.activeLoader.next(true);
  }

  hide(): void {
    this.activeLoader.next(false);
  }

}
